/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AssessmentState {
    InProgress = 0,
    InReview = 1,
    Passed = 2,
    Failed = 3,
    Aborted = 4,
}
